import Vue from 'vue'
import Router from 'vue-router'

import Hotel from "./views/Hotel";
import Reservation from "./views/Reservation";
import Confirmation from "./views/Confirmation";
import Healthy from "./views/Healthy";
import PageNotFound from "./views/errors/PageNotFound";
import InternalServerError from "./views/errors/InternalServerError";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/hotel'
    },
    {
      path: '/hotel',
      name: 'hotel',
      component: Hotel,
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('confirmed') === 'true') {
          sessionStorage.clear();
        }
        next();
      }
    },
    {
      path: '/reservation',
      name: 'reservation',
      component: Reservation,
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('confirmed') === 'true') {
          sessionStorage.clear();
          next('/hotel');
        }
        next();
      }
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: Confirmation,
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('confirmed')) {
          sessionStorage.clear();
          next('/hotel');
        }
        next();
      }
    },
    {
      path: '/healthy',
      name: 'healthy',
      component: Healthy
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound,
    },
    {
      path: '/500',
      name: '500',
      component: InternalServerError
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
